import { find, get } from "lodash";
import { MDBSpinner } from "mdbreact";
import moment from "moment";
import React, { Component } from "react";
import Loadable from "react-loadable";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { withTitle } from "~/components/common/molecules/TitleHelmet";
import LoadableLoading from "~/components/mobile/molecules/LoadingPage";
import { resetStatusScanQrCodeInsurance } from "~/store/patient/patientAction";
import {
  checkRequirePayment,
  resetPaymentMethod
} from "~/store/payment/paymentAction";
import {
  changeDirection,
  getBookingTree,
  removeSchedule,
  reserveBookingPartner,
  resetSchedule,
  saveSheduleIndex
} from "~/store/totalData/actions";
import * as constants from "~/utils/constants";
import { MOMO, TypeAction } from "~/utils/constants";
import { getPartnerFromUrl } from "~/utils/func";
import AppId from "~/utils/partner";

import { partnerInfo } from "~/configs/partnerDetails";
import {
  getMedproCare,
  updateBooking,
  selectMedproCare
} from "~/store/booking/bookingAction";

const info = get(partnerInfo, "info");
const hospitalName = find(info, { key: "name" });

const TrustInformationPageDesktop = Loadable({
  loader: () =>
    import(/* desktop */ "~/components/desktop/pages/TrustInformation"),
  loading: LoadableLoading
});

class DetectTrustInformation extends Component {
  componentDidMount() {
    const {
      resetStatusScanQrCodeInsurance,
      getBookingTree,
      schedulesSelected,
      resetPaymentMethod,
      getMedproCare,
      partnerId,
      treeId,
      room,
      service,
      subject,
      doctor,
      days,
      timeSlot
    } = this.props;

    resetPaymentMethod();

    if (schedulesSelected.length === 0) {
      const currentPagePartnerId = getPartnerFromUrl(
        this.props.history.location.pathname
      );
      getBookingTree({ partnerId: currentPagePartnerId });
    }
    let params = {};
    if (schedulesSelected.length > 0) {
      const dateStr =
        `${moment(days?.date).format("YYYY-MM-DD")}` +
        " " +
        `${timeSlot?.startTime}`;
      const bookingDate = moment(dateStr, "YYYY-MM-DD HH:mm").toISOString();
      params = {
        serviceId: service?.id,
        subjectId: subject?.id,
        doctorId: doctor?.id,
        roomId: room?.id || undefined,
        bookingDate,
        treeId,
        partnerId
      };
    }
    resetStatusScanQrCodeInsurance();
    getMedproCare(params);
  }

  methods = {
    handleAddMultiSchedule: () => {
      const currentPagePartnerId = getPartnerFromUrl(
        this.props.history.location.pathname
      );
      const { getBookingTree } = this.props;
      getBookingTree({
        partnerId: currentPagePartnerId,
        isAddNewSchedule: true
      });

      this.props.saveSheduleIndex({
        indexSchedule: -1
      });
    },
    handleNextStep: () => {
      const { reserveBookingPartner, typeAction } = this.props;

      if (typeAction === constants.TypeAction.SuaPhieuKham) {
        this.props.updateBooking();
      } else {
        if (AppId === MOMO) {
          reserveBookingPartner();
        } else {
          this.props.checkRequirePayment();
        }
      }
    },

    handleGoBack: () => {
      const {
        isRepayment,
        changeDirection,
        patient: { selectedPatient }
      } = this.props;
      let route = "";

      if (
        selectedPatient &&
        this.props.typeAction === TypeAction.SuaPhieuKham
      ) {
        this.props.resetSchedule();
        this.props.getBookingTree({
          partnerId: this.props.partnerId,
          idBooking: this.props.customerService.selectedBill?.id
        });
        return;
      } else if (isRepayment) {
        route = "/user";
      } else {
        route = "/chon-ho-so";
      }

      console.log("route: ", route);
      changeDirection();
      this.props.history.push({
        pathname: route,
        state: { activeItem: 2 }
      });
    }
  };

  render() {
    const { IsAuthenticated, schedulesSelected } = this.props;

    if (schedulesSelected.length === 0) {
      return (
        <div className="loading">
          <MDBSpinner big />
        </div>
      );
    }

    if (!IsAuthenticated) {
      return <Redirect to="/" />;
    }

    return (
      <React.Fragment>
        <TrustInformationPageDesktop {...this.props} {...this.methods} />
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  const {
    global: {
      device: { type }
    },
    patient,
    user: { IsAuthenticated },
    doctorAndTime: { alertMaxSpecialist },
    dateAndSpecialist: { selectedSpecialist },
    totalData: {
      typeAction,
      schedulesSelected,
      bookingTree,
      treeId,
      room,
      service,
      subject,
      doctor,
      days,
      timeSlot,
      hospitalSelected,
      isRepayment,
      partnerId,
      subject: { isHasSubject },
      service: { isHasService },
      room: { isHasRoom },
      doctor: { isHasDoctor },
      flow,
      extraConfig
    },
    customerService,
    hospital: { selectedHospital },
    booking: { isUpdatingBooking, medproCare, addonMedproCare }
  } = state;
  const selectedDate = moment(state.dateAndSpecialist.selectedDate).format(
    "DD-MM-YYYY"
  );
  return {
    flow,
    extraConfig,
    typeAction,
    patient,
    IsAuthenticated,
    device: type,
    alertMaxSpecialist,
    selectedSpecialist,
    selectedDate,
    schedulesSelected,
    bookingTree,
    treeId,
    room,
    service,
    subject,
    doctor,
    days,
    timeSlot,
    hospitalSelected,
    isRepayment,
    partnerId,
    selectedHospital,
    isHasSubject,
    isHasService,
    isHasRoom,
    isHasDoctor,
    customerService,
    isUpdatingBooking,
    medproCare,
    addonMedproCare
  };
};

const TrustInformationHelmet = withTitle({
  component: DetectTrustInformation,
  title: `${hospitalName.value} | Xác nhận thông tin đặt khám`
});

export default connect(mapStateToProps, {
  changeDirection,
  resetStatusScanQrCodeInsurance,
  reserveBookingPartner,
  getBookingTree,
  resetSchedule,
  checkRequirePayment,
  resetPaymentMethod,
  updateBooking: updateBooking,
  saveSheduleIndex: saveSheduleIndex,
  removeSchedule: removeSchedule,
  getMedproCare,
  selectMedproCare
})(TrustInformationHelmet);
